export function parseInputValue(
  value: React.InputHTMLAttributes<HTMLInputElement>['value'],
): number {
  return Number.parseFloat(String(value).replace('$', ''))
}
